import { CAST_AI } from '@cast/constants';
import { ComputedNodeStatus, NodeStatePhase, NodeStatus } from '@cast/types';

import { NodeProvisioner } from '../_types/provisioner';

export const NODE_STATE_PHASE_LABELS: Record<NodeStatePhase, string> = {
  [NodeStatus.ready]: 'Ready',
  'not-ready': 'Not ready',
  [NodeStatus.creating]: 'Creating',
  [NodeStatus.pending]: 'Pending',
  [NodeStatus.deleting]: 'Deleting',
  [NodeStatus.deleted]: 'Deleted',
  [NodeStatus.draining]: 'Draining',
  [ComputedNodeStatus.CORDONED]: 'Cordoned',
  [ComputedNodeStatus.DISRUPTED]: 'Disrupted',
  [NodeStatus.interrupted]: 'Interrupted',
  [NodeStatus.unknown]: 'Unknown',
  [NodeStatus.detached]: 'Detached',
};

export const NODE_PROVISIONER_DISPLAY_NAMES: Record<NodeProvisioner, string> = {
  castai: CAST_AI,
  aks: 'AKS',
  eks: 'EKS',
  gke: 'GKE',
  karpenter: 'Karpenter',
  unknown: 'Other',
};
